const CustomUcSettingMenu = [
  {
    icon: "phone_missed",
    key: "uc.missed-calls",
    name: "Missed calls",
    description: "Missed incoming calls",
    url: "home/app/uc/missed-calls",
    productionReady: true,
  },
  {
    icon: "contacts",
    key: "uc.contacts",
    name: "Contacts",
    description: "Phone Book",
    url: "home/app/uc/contacts",
    productionReady: true,
  },
  {
    icon: "list",
    key: "uc.history",
    name: "Call History",
    description: "Call History",
    url: "home/app/uc/cdr",
    productionReady: true,
  },
  {
    icon: "account_box",
    key: "uc.settings",
    name: "User Profile",
    description: "User Profile",
    url: "home/app/uc/settings",
    productionReady: true,
  },

  {
    icon: "message",
    key: "uc.conference.addParticipant",
    name: "Meeting Participant",
    url: "home/app/uc/MeetingParticipant",
    disabled: true,
    productionReady: true,
  },
];
  
  export { CustomUcSettingMenu };
  